import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useLocation } from 'react-router';

export const useSmoothScrollTo = (isLoading: boolean = false): void => {
    const history = useHistory();
    const location = useLocation();

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const scrollPosition = searchParams.get('scrollPosition');

        if (!isLoading && scrollPosition) {
            const scrollContainer: HTMLElement = document.getElementById('scrollContainer');
            setTimeout(() => {
                scrollContainer.scrollTo(0, parseInt(scrollPosition, 10));
            }, 1000);
            searchParams.delete('scrollPosition');
            history.replace({ search: searchParams.toString() });
        }
    }, [isLoading, location]);
};
